<template>
    <on-click-outside :do="hide">
        <div>
            <button
                v-if="isSearch"
                :class="{ 'is-active': show }"
                aria-label="Visa meny"
                class="dropdown-trigger is-search relative"
                @click="toggle"
            >
                <transition name="fade">
                    <font-awesome-icon
                        v-if="show"
                        key="open"
                        icon="times"
                        class="absolute"
                    />
                    <font-awesome-icon
                        v-else
                        key="closed"
                        icon="search"
                        class="absolute"
                    />
                </transition>
            </button>
            <button
                v-else
                :class="{ 'is-active': show, [triggerClasses]: true }"
                class="dropdown-trigger"
                aria-label="Visa meny"
                @click="toggle"
            >
                <slot />
            </button>

            <transition name="slide-down">
                <div
                    v-show="show"
                    :class="{ 'has-full-width': fullWidth, 'has-full-height': fullHeight, [contentClasses]: true }"
                    class="dropdown-content shadow-dropdown"
                >
                    <slot name="dropdown-content" />
                </div>
            </transition>

            <portal to="overlay">
                <transition v-if="show" name="fade">
                    <div class="fixed z-40 h-screen w-screen top-0 bg-modal overflow-hidden" />
                </transition>
            </portal>
        </div>
    </on-click-outside>
</template>

<script>
    export default {
        props: {
            isSearch: {
                type: Boolean,
                default: false,
            },
            fullWidth: {
                type: Boolean,
                default: false,
            },
            fullHeight: {
                type: Boolean,
                default: false,
            },
            triggerClasses: {
                type: String,
                default: null,
            },
            contentClasses: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                show: false,
            };
        },

        methods: {
            toggle() {
                this.setShow(! this.show);
                if (this.isSearch && this.show) {
                    EventBus.$emit('header-search-opened');
                }
            },
            hide() {
                this.setShow(false);
            },
            setShow(value) {
                if (this.show !== value) {
                    this.show = value;
                    this.handleNoScrollToggle(value);
                }
            },
        },

    };
</script>
